// extracted by mini-css-extract-plugin
export default {"coming-soon":"ComingSoon_coming-soon__UXMHi","heading":"ComingSoon_heading__LPLFn","tagline":"ComingSoon_tagline__LPFkq","doggie":"ComingSoon_doggie__wPBxT"};